/* eslint-disable prettier/prettier */
import Vue from "vue";
import VueRouter from "vue-router";
import MddLogin from "./components/MddLogin.vue";
import MddInicio from "./components/MddInicio.vue";
import MddPaginaDia from "./components/libro/MddPaginaDia.vue";
import MddPagina from "./components/paginas/MddPagina.vue";
import MddInstalar from "./components/paginas/MddInstalar.vue";
import store from "./store/_store";
import infoo from "./plugins/infoo";
import MddCuadernoDia from "./components/cuaderno/MddCuadernoDia.vue";
import MddUser from "./components/MddUser.vue";
import MddCuadernoMes from "./components/cuaderno/MddCuadernoMes.vue";
import MddLecturasBiblicas from "./components/lecturas/MddLecturasBiblicas.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // home
    {
      path: "/",
      name: "home",
      component: MddInicio,
      props: () => ({ infooHoy: infoo.hoy })
    },
    // login
    {
      path: "/login",
      name: "login",
      component: MddLogin
    },
    // about
    {
      path: "/about",
      name: "about",
      component: MddPagina,
      props: { doc: "about" }
    },
    // instalar
    {
      path: "/instalar",
      name: "instalar",
      component: MddInstalar
    },
    // legal
    {
      path: "/legal",
      name: "legal",
      component: MddPagina,
      props: { doc: "legal" }
    },
    // user
    {
      path: "/user",
      name: "user",
      component: MddUser
    },
    // MddCuadernoDia
    {
      path: "/cuaderno-dia/:anio([0-9]{4})/:mes([0-9]{1,2})/:dia([0-9]{1,2})",
      name: "MddCuadernoDia",
      component: MddCuadernoDia,
      beforeEnter: (to, from, next) => {
        // TODO: validar el periodo que puede consultar
        // context.min se calcula de la fecha minima de la version del libro
        let hoy = infoo.hoy;
        let params = to.params;

        let dateMin = store.state.app.context.min || hoy.min; // fecha en formato iso
        let dateMax = store.state.app.context.max;
        let dateTo = infoo.fechaAMD(params.anio, params.mes, params.dia).iso;
        
        if (dateTo < dateMin) {
          dateMin = infoo.fechaIso(dateMin);
          params.dia = dateMin.dia;
          params.mes = dateMin.mes;
          params.anio = dateMin.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }
    
        if (dateTo > dateMax) {
          dateMax = infoo.fechaIso(dateMax);
          params.dia = dateMax.dia;
          params.mes = dateMax.mes;
          params.anio = dateMax.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }

        // al terminar la validacion carga
        store.dispatch("lectio/load", params);
        next();
      }
    },
    // MddCuadernoMes
    {
      path:
        "/cuaderno/:anio([0-9]{4})/:mes([0-9]{1,2})",
      name: "MddCuadernoMes",
      component: MddCuadernoMes,
      beforeEnter: (to, from, next) => {
        // TODO: validar el periodo que puede consultar
        // context.min se calcula de la fecha minima de la version del libro
        let hoy = infoo.hoy;
        let params = to.params;

        let dateMin = store.state.app.context.min || hoy.min; // fecha en formato iso
        let dateMax = store.state.app.context.max;
        let dateTo = infoo.fechaAMD(params.anio, params.mes, params.dia).iso;
        
        if (dateTo < dateMin) {
          dateMin = infoo.fechaIso(dateMin);
          params.dia = dateMin.dia;
          params.mes = dateMin.mes;
          params.anio = dateMin.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }
    
        if (dateTo > dateMax) {
          dateMax = infoo.fechaIso(dateMax);
          params.dia = dateMax.dia;
          params.mes = dateMax.mes;
          params.anio = dateMax.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }

        // al terminar la validacion carga
        store.dispatch("lectio/load", params);
        next();
      }
    },
    // MddLecturasBiblicas
    {
      path:
        "/lecturas/:anio([0-9]{4})/:mes([0-9]{1,2})/:dia([0-9]{1,2})/:lng([a-z]{2})/:ver([a-z]{0,2})?",
      name: "MddLecturasBiblicas",
      component: MddLecturasBiblicas,
      beforeEnter: (to, from, next) => {
        // TODO: cambiar esta referencia directa
        // context.min se calcula de la fecha minima de la version del libro
        let hoy = infoo.hoy;
        let params = to.params;

        let dateMin = store.state.app.context.min || hoy.min; // fecha en formato iso
        let dateMax = store.state.app.context.max;
        let dateTo = infoo.fechaAMD(params.anio, params.mes, params.dia).iso;
        
        if (dateTo < dateMin) {
          dateMin = infoo.fechaIso(dateMin);
          params.dia = dateMin.dia;
          params.mes = dateMin.mes;
          params.anio = dateMin.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }
    
        if (dateTo > dateMax) {
          dateMax = infoo.fechaIso(dateMax);
          params.dia = dateMax.dia;
          params.mes = dateMax.mes;
          params.anio = dateMax.anio;
          store.dispatch("lectio/load", params);
          next({ name: "MddLecturas", params: params });
          return;
        }

        // al terminar la validacion carga
        store.dispatch("lectio/load", params);
        next();
      }
    },
    // MddPaginaDia
    {
      path:
        "/oracion/:filter/:anio([0-9]{4})/:mes([0-9]{1,2})/:dia([0-9]{1,2})/:lng([a-z]{2})/:ver([a-z]{0,2})?",
      name: "MddPaginaDia",
      component: MddPaginaDia,
      beforeEnter: (to, from, next) => {
        let hoy = infoo.hoy;
        if (to.params.dia !== hoy.dia || to.params.mes !== hoy.mes || to.params.anio !== hoy.anio) {
          let params = to.params;
          params.anio = hoy.anio
          params.mes = hoy.mes
          params.dia = hoy.dia
          
          store.dispatch("lectio/load", params);
          next({ name: "MddPaginaDia", params: params });
        }
        
        store.dispatch("lectio/load", to.params);
        next();
      }
    },
    // *
    {
      path: "*",
      redirect: { name: 'home' }
    }
  ]
});

router.onReady(
  () => {
    // cuando ha resuelto las solicitudes asinctronas al inicio
  },
  (e) => {
    // error, por ejemplo al intentar cargar un componente asíncrono
    // TODO: beta
    store.dispatch("app/saveErrorReport", {
      file: "router",
      line: 66,
      e: e
    });
  }
);

router.onError((e) => {
  // https://router.vuejs.org/api/#router-onerror
  store.dispatch("app/saveErrorReport", {
    src: "router",
    line: 81,
    e: e
  });
});

// https://router.vuejs.org/guide/advanced/navigation-guards.html#the-full-navigation-resolution-flow
router.beforeEach((to, from, next) => {
  if (!infoo.appStart) {
    infoo.toAfterStart = to
  } else {
    next();
  }
});

export default router;
